import React, { Component } from 'react';
import Map from '../map/map_index'
import ReactGA from 'react-ga';

class Covid extends Component {

    constructor(props) {
        super(props)
        this.state = {
            open: false
        };

    }

    componentDidMount() {
        ReactGA.initialize('UA-162474760-1');
        ReactGA.pageview(window.location.pathname + window.location.search)
        console.log('this.props.match.params.riskPotential', this.props.match.params.riskPotential)
        console.log('window.frameElement', window.title)
    }


    render() {

        const classes = this.props.classes;
        const { open } = this.state
        console.log('this.props.history', this.props.history)
        return (
            <Map containerStyle={{ width: '100%', height: '100%' }}
                mapId={this.props.match.params.id}
                riskPotentials={[this.props.match.params.riskPotential]}
            ></Map>
        );
    }
}

export default Covid;


